import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { Fragment } from "react"
import InfoIcon from "../../../../InfoIcon"
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { userActions } from "../../../../../store/user-slice"

const ResortIcons = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredUsers = useSelector((state) => state.user.filteredUsers)
    let users=useSelector(state=>state.user.users)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(userActions.setFilteredItems(resort(filteredUsers??users, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(userActions.setFilteredItems(resort(filteredUsers??users, type, 'DESC')))
        }} />
    </Fragment>
}

export default ResortIcons